import React, { Component } from 'react'
import { AUTH_CONFIG } from '../Auth/auth0-variables';
import { connect } from 'react-redux'
import moment from 'moment'
import axios from 'axios';
import { areIntervalsOverlapping, endOfWeek, startOfMonth, getDay,previousSunday, previousMonday, previousTuesday, previousWednesday, previousThursday, previousFriday, previousSaturday,addWeeks, startOfWeek, addDays, eachDayOfInterval, isWithinInterval, subMonths } from 'date-fns'
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'
import { extendMoment } from 'moment-range';

import _ from "lodash"
const ShiftsContext = React.createContext()
const extendedMoment = extendMoment(moment);

// Feature flag: when true, admin users see the new full-height left sidebar
// (AdminNav) instead of the legacy top-nav + sidebar combo. Centralized here
// so the app has a single source of truth.
export const USE_NEW_NAV = false;


class ShiftsProvider extends Component {
    // Context state
    constructor(props) {
        super(props);
        const isMobileOrTablet = window.matchMedia("(max-width: 1024px)").matches;


        this.state = {
            shifts: [],
            filteredShifts: [],
            filteredViewShifts:[],
            calendarShifts: [],
            jobs: [],
            schedules: [],
            selectedSchedules: [],
            selectedScheduleId:null,
            publishedSelected:null,
            facilityId: undefined, //localStorage.getItem("last_facility"),
            employees: this.props.employees ? [...this.props.employees] : [],
            isFetchingShifts: true,
            isFetchingJobs: true,
            selectedDay: new moment().toDate(),
            calendarStartDate: startOfWeek(startOfMonth(moment().toDate())),
            calendarEndDate: endOfWeek(addWeeks(startOfWeek(startOfMonth(moment().toDate())), 5)),
            currentStartDate: undefined,
            minScheduleDate:undefined,
            currentEndDate: undefined,
            scheduleDays: [],
            shiftTypes:[],
            jobCodes: [],
            filterXRoles: [],
            filterXShifts: [],
            filterXEmployees: [],
            filterXJobCodes: [],
            filterXDepartmentRoles: [],
            filteredEmployees: this.props.employees ? _.sortBy([...this.props.employees], ["role", "firstName"]) : [],
            conflictCount: 0,
            usersWithOvertime:[],
            openShiftCount:0,
            showConflictBtn: false,
            itemIndrag: {},
            scheduleConflictsOnly: false,
            autoFillOnly: false,
            filterAvailability:null,
            clearingScheduler: false,
            initLoading: true,
            showAvail: localStorage.getItem("showAvail") == 'false' ? false : true,
            currentShiftStartDate: new moment().toDate(),
            currentShiftsEndDate: new moment().toDate(),
            weather: [],
            unfinishedCourses:[],
            trial: false,
            showProfilePic: false,
            navOpen: isMobileOrTablet ? false : true,
            scheduleType: localStorage.getItem("scheduleType") ? localStorage.getItem("scheduleType") : "employee",
            overtimeSettings: this.props.overtimeSettings,
            showAll: localStorage.getItem("showAll") ? localStorage.getItem("showAll") === 'true' ? true : false : false,
            showTotals: localStorage.getItem("showTotals") ? localStorage.getItem("showTotals") === 'true' ? true : false : true,
            showFilterbar: localStorage.getItem('showFilterbar') !== 'false',
            copiedScheduleId: null,
            copiedWeekDays: [],
            showCreateSchedule: false,
        }
    }

    componentDidMount() {
        if (this.state.facilityId) {
            this.getSchedules()
            this.getShiftTypes();
            this.getFormsForShifts();
            this.getOvertimeSettings();
        }
        if (this.props.clientsModule) {
            this.getJobCodes();
        }
    }

    setShowAll = (show) => {
        this.setState({ showAll: show }, this.recalculateShiftSummaries);
        localStorage.setItem("showAll", show)
    }

    openCreateSchedule = () => {
        this.setState({ showCreateSchedule: true });
    }

    closeCreateSchedule = () => {
        this.setState({ showCreateSchedule: false });
    }

    setShowTotals = (value) => {
        this.setState({ showTotals: value });
        localStorage.setItem("showTotals", value);
    }

    setShowFilterbar = (value) => {
        this.setState({ showFilterbar: value });
        localStorage.setItem('showFilterbar', value);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.clientsModule && !this.props.clientsModule) {
            this.getJobCodes();
        }
        if (nextProps.facilityId !== this.props.facilityId) {
            this.clearCopiedWeekSelection();
            this.setState({
                facilityId: nextProps.facilityId,
                usersWithOvertime: [],
                jobs: [],
                isFetchingJobs: true
            }, () => {
                this.getSchedules();
                this.getShiftTypes();
                this.getFormsForShifts();
                this.refreshVisibleData();
            });
        }
        if (nextProps.StartOfWorkweek !== this.props.StartOfWorkweek) {
            this.setState({
                StartOfWorkweek: nextProps.StartOfWorkweek
            }, () => {
                if (this.state.facilityId) {
                    this.getSchedules()
                }
                
            });
        }
        if (nextProps.employees !== this.props.employees) {
            this.setState({
                employees: nextProps.employees,
                filteredEmployees: _.sortBy([...nextProps.employees], ["role", "firstName"]),
            }, this.recalculateShiftSummaries);
        }
        if (nextProps.overtimeSettings !== this.props.overtimeSettings) {
            this.setState({
                overtimeSettings: nextProps.overtimeSettings
            });
        }
        
    }

    getDateNumber = (d) =>{
        if (d === "sun") {
            return 0;
        } else if (d === "mon") {
            return 1;
        } else if (d === "tue") {
            return 2;
        } else if (d === "wed") {
            return 3;
        } else if (d === "thu") {
            return 4;
        } else if (d === "fri") {
            return 5;
        } else if (d === "sat") {
            return 6;
        }
    }

    startOfWeek = (d) => {
        //0 represents Sunday
        const day = getDay(new Date(d))
        const clDay = this.getDateNumber(this.state.StartOfWorkweek);
        const sw = this.state.StartOfWorkweek;
        if (day === clDay) {
            return d;
        } else if (sw === "sun") {
            return previousSunday(d);
        } else if (sw === "mon") {
            return previousMonday(d);
        } else if (sw === "tue") {
            return previousTuesday(d);
        } else if (sw === "wed") {
            return previousWednesday(d);
        } else if (sw === "thu") {
            return previousThursday(d);
        } else if (sw === "fri") {
            return previousFriday(d);
        } else if (sw === "sat") {
            return previousSaturday(d);
        }
    }

    isStartOfWeek = (d) => {
        //0 represents Sunday
        const day = getDay(new Date(d))
        const clDay = this.getDateNumber(this.state.StartOfWorkweek);
        if (day === clDay) {
            return true;
        } else {
            return false;
        } 
    }

    isDayBeforeStartOfWeek = (d) => {
        //0 represents Sunday
        const day = getDay(new Date(d));
        let clDay = this.getDateNumber(this.state.StartOfWorkweek);

        // find the previous day, wrapping around Sunday -> Saturday
        const prevDay = (clDay - 1 + 7) % 7;

        return day === prevDay;
    }

    // Returns TOTAL overtime hours (daily + weekly residual) as a decimal.
    // - Daily OT = minutes over 8h and/or over 12h per shift, depending on toggles
    // - Weekly OT = minutes over the weekly threshold AFTER subtracting daily OT already counted
    // - No double counting
    calculateOvertimeHours = (shifts, salariedOvertimeEligible, payrollType, salariedStartDate, wage) => {
        const summary = this.getOvertimeBuckets(shifts, salariedOvertimeEligible, payrollType, salariedStartDate, wage);
        return summary.totalOvertimeHours;
    };

    getOvertimeBuckets = (shifts, salariedOvertimeEligible, payrollType, salariedStartDate, wage) => {
        if (!Array.isArray(shifts) || shifts.length === 0 || !this.state?.overtimeSettings) {
            return {
                totalOvertimeHours: 0,
                dailyOver8Hours: 0,
                dailyOver12Hours: 0,
                weeklyOvertimeHours: 0
            };
        }

        const {
            salariedOvertime,
            startOfWorkweek,
            dailyOvertime8,
            dailyOvertime12,
            weeklyOvertime,
            weeklyOvertimeHours
        } = this.state.overtimeSettings;

        const SALARIED_WAGE_CAP = 35568.0;
        const parseMoney = (val) => {
            if (typeof val === "number") return val;
            if (typeof val === "string") {
                const n = parseFloat(val.replace(/[^0-9.-]/g, ""));
                return Number.isFinite(n) ? n : NaN;
            }
            return NaN;
        };
        const wageNum = parseMoney(wage);
        const salariedStart = salariedStartDate ? new Date(salariedStartDate) : null;

        const dayOfWeekMap = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
        const startDow = dayOfWeekMap[(startOfWorkweek || "sun").toLowerCase()] ?? 0;
        const toMinutes = (ms) => Math.max(0, Math.floor(ms / 60000));
        const getWeekStartKey = (d) => {
            const day = d.getDay();
            const diff = (7 + (day - startDow)) % 7;
            const ws = new Date(d);
            ws.setHours(0, 0, 0, 0);
            ws.setDate(ws.getDate() - diff);
            return ws.getTime();
        };

        const weeklyEligibleMinutes = {};
        const weeklyDailyOTMinutes = {};
        const dailyEligibleMinutes = {};
        let totalDailyOver8Min = 0;
        let totalDailyOver12Min = 0;

        const ordered = [...shifts].sort(
            (a, b) => new Date(a.fullStartTime) - new Date(b.fullStartTime)
        );

        for (const s of ordered) {
            const start = new Date(s.fullStartTime);
            const end = new Date(s.fullEndTime);
            const minutes = toMinutes(end - start);
            if (minutes <= 0 || Number.isNaN(minutes)) continue;

            const wk = getWeekStartKey(start);
            if (weeklyEligibleMinutes[wk] == null) weeklyEligibleMinutes[wk] = 0;
            if (weeklyDailyOTMinutes[wk] == null) weeklyDailyOTMinutes[wk] = 0;

            const isSalariedShift =
                payrollType === 2 &&
                !(salariedStart instanceof Date && salariedStart > start);

            const salariedEligibleThisShift =
                isSalariedShift &&
                !!salariedOvertime &&
                !!salariedOvertimeEligible &&
                Number.isFinite(wageNum) &&
                wageNum <= SALARIED_WAGE_CAP;

            if (!isSalariedShift || salariedEligibleThisShift) {
                weeklyEligibleMinutes[wk] += minutes;
            }

            const countDailyOT = !isSalariedShift || salariedEligibleThisShift;
            if (countDailyOT) {
                const dayKeyDate = new Date(start);
                dayKeyDate.setHours(0, 0, 0, 0);
                const dayKey = dayKeyDate.getTime();
                if (!dailyEligibleMinutes[dayKey]) {
                    dailyEligibleMinutes[dayKey] = {
                        minutes: 0,
                        weekKey: wk
                    };
                }
                dailyEligibleMinutes[dayKey].minutes += minutes;
            }
        }

        Object.values(dailyEligibleMinutes).forEach(entry => {
            const minutes = entry.minutes;
            if (!minutes || minutes <= 0) {
                return;
            }

            let d8 = 0;
            let d12 = 0;

            if (dailyOvertime12 && minutes > 12 * 60) {
                d12 = minutes - 12 * 60;
            }

            if (dailyOvertime8 && minutes > 8 * 60) {
                const upperBound = dailyOvertime12 ? Math.min(minutes, 12 * 60) : minutes;
                d8 = Math.max(0, upperBound - 8 * 60);
            }

            totalDailyOver8Min += d8;
            totalDailyOver12Min += d12;

            const wk = entry.weekKey;
            if (weeklyDailyOTMinutes[wk] == null) {
                weeklyDailyOTMinutes[wk] = 0;
            }
            weeklyDailyOTMinutes[wk] += d8 + d12;
        });

        let totalWeeklyResidualMin = 0;
        if (weeklyOvertime && Number.isFinite(weeklyOvertimeHours) && weeklyOvertimeHours > 0) {
            const weeklyThresholdMin = weeklyOvertimeHours * 60;
            for (const wk of Object.keys(weeklyEligibleMinutes)) {
                const eligible = weeklyEligibleMinutes[wk] || 0;
                const dailyAlreadyCounted = weeklyDailyOTMinutes[wk] || 0;
                const rawWeeklyOverMin = Math.max(0, eligible - weeklyThresholdMin);
                const weeklyResidualMin = Math.max(0, rawWeeklyOverMin - dailyAlreadyCounted);
                totalWeeklyResidualMin += weeklyResidualMin;
            }
        }

        const totalDailyOTMin = totalDailyOver8Min + totalDailyOver12Min;
        const totalOTHours = (totalDailyOTMin + totalWeeklyResidualMin) / 60;

        return {
            totalOvertimeHours: Number(totalOTHours.toFixed(2)),
            dailyOver8Hours: Number((totalDailyOver8Min / 60).toFixed(2)),
            dailyOver12Hours: Number((totalDailyOver12Min / 60).toFixed(2)),
            weeklyOvertimeHours: Number((totalWeeklyResidualMin / 60).toFixed(2))
        };
    };

    resolvePayRateForDate = (payRates = [], roleId, targetDate, wageTypeFilter) => {
        if (!Array.isArray(payRates) || !targetDate) return null;
        const target = new Date(targetDate);

        const exactMatch = payRates
            .filter(rate => {
                const sameType = wageTypeFilter == null || rate.wageType === wageTypeFilter;
                const sameRole =
                    roleId == null ||
                    rate.roleId === roleId ||
                    rate.roleId == null;
                return sameType && sameRole && new Date(rate.effectiveDate) <= target;
            })
            .sort((a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate));

        return exactMatch.length > 0 ? exactMatch[0] : null;
    };

    calculateSalaryPay = (user = {}, payRates = [], calendarDays = [], shifts = []) => {
        const salaryRates = (payRates || []).filter(r => r.wageType === 2);
        if (salaryRates.length === 0 && user.payrollType !== 2) {
            return 0;
        }

        const uniqueDays = calendarDays.length
            ? calendarDays.map(day => day.day)
            : Array.from(new Set(shifts.map(s => s.date || s.fullStartTime)));

        if (uniqueDays.length === 0 && salaryRates.length === 0) {
            return 0;
        }

        const dayList = uniqueDays.length
            ? uniqueDays
            : [new Date()];

        const daysInYear = (year) => ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) ? 366 : 365;

        let total = 0;
        for (const day of dayList) {
            const rate = this.resolvePayRateForDate(salaryRates, null, day, 2);
            const annualSalary = Number(rate?.wage ?? (user?.payrollType === 2 ? user?.wage : 0) ?? 0);
            if (annualSalary > 0) {
                const yr = new Date(day).getFullYear();
                total += annualSalary / daysInYear(yr);
            }
        }

        return total;
    };

    calculateEmployeePay = (user, shifts = [], options = {}) => {
        if (!user || !Array.isArray(shifts)) {
            return {
                hourlyPay: 0,
                salaryPay: 0,
                overtimePremium: 0,
                totalPay: 0,
                overtimeBreakdown: this.getOvertimeBuckets([], false, null, null, null)
            };
        }

        const payRates = Array.isArray(user.payRates) ? user.payRates : [];
        let hourlyPay = 0;
        let hourlyMinutes = 0;

        const parseHours = (shift) => {
            if (typeof shift.shiftHours === 'number') return shift.shiftHours;
            const start = shift.fullStartTime ? new Date(shift.fullStartTime) : null;
            const end = shift.fullEndTime ? new Date(shift.fullEndTime) : null;
            if (!start || !end) return 0;
            return Math.max(0, (end - start) / 3600000);
        };

        shifts.forEach(shift => {
            const hours = parseHours(shift);
            if (hours <= 0) {
                return;
            }
            const rateInfo = this.resolvePayRateForDate(
                payRates,
                shift.requiredRoleId ?? shift.roleId ?? null,
                shift.date || shift.fullStartTime,
                1
            );
            const isHourly = (rateInfo?.wageType ?? user?.payrollType) === 1;
            if (!isHourly) {
                return;
            }
            const rate = Number(rateInfo?.wage ?? user?.wage ?? 0);
            hourlyPay += rate * hours;
            hourlyMinutes += hours * 60;
        });

        const salaryPay = this.calculateSalaryPay(
            user,
            payRates,
            options.calendarDays || this.state.scheduleDays,
            shifts
        );

        const overtimeBreakdown = this.getOvertimeBuckets(
            shifts,
            user?.salariedOvertimeEligible,
            user?.payrollType,
            user?.salariedStartDate,
            user?.wage
        );

        const averageHourlyRate = hourlyMinutes > 0
            ? hourlyPay / (hourlyMinutes / 60)
            : Number(user?.wage ?? 0);

        const settings = this.state?.overtimeSettings || {};
        const daily8Multiplier = Number(settings.dailyOvertimePay8) || 1.5;
        const daily12Multiplier = Number(settings.dailyOvertimePay12) || 2;
        const weeklyMultiplier = Number(settings.weeklyOvertimePay) || 1.5;

        const overtimePremium =
            Math.max(daily8Multiplier - 1, 0) * overtimeBreakdown.dailyOver8Hours * averageHourlyRate +
            Math.max(daily12Multiplier - 1, 0) * overtimeBreakdown.dailyOver12Hours * averageHourlyRate +
            Math.max(weeklyMultiplier - 1, 0) * overtimeBreakdown.weeklyOvertimeHours * averageHourlyRate;

        const totalPay = Number(
            (hourlyPay + salaryPay + Math.max(overtimePremium, 0)).toFixed(2)
        );

        return {
            hourlyPay: Number(hourlyPay.toFixed(2)),
            salaryPay: Number(salaryPay.toFixed(2)),
            overtimePremium: Number(Math.max(overtimePremium, 0).toFixed(2)),
            totalPay,
            overtimeBreakdown
        };
    };

    setShowAvail = (x) => {
        this.setState({ showAvail: x })
    }

    showsScheduleConflictsOnly = (x) => {
        this.setState({ scheduleConflictsOnly: x })
    }

    showAutoFillOnly = (x) => {
        this.setState({ autoFillOnly: x })
    }

    setItemIndrag = (item) => {
        this.setState({ itemIndrag: item })
    }

    setTrial = (x) => {
        this.setState({ trial: x })
    }

    setViewDates = (start, end) => {
        if (end >= this.state.currentStartDate && start <= this.state.currentEndDate) {

        }
    }

    getJobCodes = () => {
        axios.get(AUTH_CONFIG.API_URL + "/api/Account/GetTimecardClients")
            .then((response) => {
                this.setState({
                    jobCodes: (response.data || []).map(x => ({ key: x.timecardClientId, text: x.name }))
                });
            });
    }

    getShiftTypes = () => {
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetShiftTypes")
            .then((response) => {
                var items = [];
                response.data.forEach((element, index) => {
                    const item = {
                        key: element.shiftTypeId,
                        text: element.name,
                        color: element.color,
                        startTime: element.startTime,
                        endTime: element.endTime,
                        colorId: element.colorId
                    };
                    items.push(item);
                });
                items.push({
                    key: 0,
                    text: 'Custom'
                })
                this.setState({
                    shiftTypes: items
                });
            });
    }

    setIsFetchingJobs = () => {
        this.setState({ isFetchingJobs: false})
    }

    getJobs = (scheduleId, startDate, endDate) => {
        if (!startDate || !endDate) {
            this.setState({ jobs: [], isFetchingJobs: false });
            return;
        }

        // simple boolean in-flight guard to prevent concurrent requests
        if (this._getJobsInFlight && this._getJobsScheduleId === scheduleId) {
            return;
        }

        this._getJobsInFlight = true;
        this._getJobsScheduleId = scheduleId;
        this.setState({ isFetchingJobs: true });

        const params = {
            facilityId: this.state.facilityId,
            scheduleId,
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD')
        };

        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/Jobs", { params })
            .then((response) => {
                const jobs = response.data || [];
                console.log('right after')
                console.log(JSON.stringify(jobs))
                this.setState({
                    jobs,
                    isFetchingJobs: false
                });
            })
            .catch((error) => {
                this.setState({ isFetchingJobs: false });
            })
            .finally(() => {
                this._getJobsInFlight = false;
            });
    }

    fetchWeather = () => {
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetWeatherIcons?facilityId=" + this.state.facilityId)
            .then((response) => {
                var weather = [];
                try {
                    var tmp = JSON.parse(response.data);
                    weather = tmp.daily
                    weather.forEach(x => x.dt = moment.unix(x.dt).format('YYYY-MM-DDT00:00:00'));
                } catch (e) {
                    var x = e;
                }
                this.setState({ weather: weather })
            });
    }

    // Filter Shifts
    filterShifts = () => {
        
        let tmpShifts = this.state.shifts;
        let filteredShifts = [...this.state.shifts];
        //let selectedScheduleIds = this.state.selectedSchedules.map(x => x.scheduleId);
        //
        //if (selectedScheduleIds.length > 0) {
        //    filteredShifts = tmpShifts.filter(x => selectedScheduleIds.includes(x.scheduleId))
        //}

        if (this.state.filterXShifts.length > 0) {
            filteredShifts = tmpShifts.filter(y => {
                const label = y.description ?? y.roleName ?? '';
                const key = label + y.formatStartEndTime;
                return this.state.filterXShifts.includes(key);
            });
        }

        if (this.state.filterXEmployees.length > 0) {
            filteredShifts = tmpShifts.filter(y => this.state.filterXEmployees.includes(y.userId));
        }

        if (this.state.filterXRoles.length > 0) {
            filteredShifts = tmpShifts.filter(y => this.state.filterXRoles.includes(y.roleId));
        }

        if (this.state.filterXDepartmentRoles.length > 0) {
            //filterXDepartmentRoles
            filteredShifts = tmpShifts.filter(y => this.state.filterXDepartmentRoles.includes(y.roleId));
        }

        if (this.state.filterXJobCodes.length > 0) {
            filteredShifts = tmpShifts.filter(y => this.state.filterXJobCodes.includes(y.timecardClientId));
        }

        let grouped_users = _.groupBy(filteredShifts, 'userId')
        delete grouped_users['null']

        var user = null;
        let _this = this;
        _.forEach(grouped_users, function (value, key) {
            // check for pto or availability
            user = _this.state.employees.filter(x => x.userId == key)[0]
            value.map((r, index) => {
                if (!user) {
                    debugger
                }
                //if (filteredShifts.length) {
                //    debugger

                //}
                // if (user.userId == 94437) {
                //     debugger;
                // }
                if (user.pto.length > 0) {
                    if (_this.availableConflictsPto(r.fullStartTime, r.fullEndTime, user.pto)) {
                        filteredShifts.find(e => e.assignedShiftID === r.assignedShiftID).conflicts = 3;
                        return;
                    }
                }

                var o = value.filter(q => q != r).map(q =>
                    extendedMoment.range(
                        extendedMoment(q.fullStartTime),
                        extendedMoment(q.fullEndTime)
                    ).overlaps(
                        extendedMoment.range(
                            extendedMoment(r.fullStartTime),
                            extendedMoment(r.fullEndTime)
                        )
                    )
                ).includes(true)
                
                if (o) {
                    filteredShifts.find(e => e.assignedShiftID === r.assignedShiftID).conflicts = 1;
                } else if (r.assignedShiftID && user.availability.length > 0 && _this.availableConflicts(r.fullStartTime, r.fullEndTime, user.availability, user)) {
                    filteredShifts.find(e => e.assignedShiftID === r.assignedShiftID).conflicts = 2;
                } else {
                    filteredShifts.find(e => e.assignedShiftID === r.assignedShiftID).conflicts = false;
                }
            });
        });

       this.setState({
            filteredShifts: filteredShifts,
           unpublishedAutofill: this.state.shifts.filter(x => x.unpublishedAutofill).length,
        }, this.recalculateShiftSummaries)
    }

    recalculateShiftSummaries = () => {
        const { filteredShifts, scheduleDays, selectedScheduleId, employees, filteredEmployees, showAll } = this.state;

        let viewShifts = filteredShifts;
        if (scheduleDays.length > 0 && filteredShifts.length > 0) {
            const start = moment(scheduleDays[0].day).toDate();
            const end = moment(scheduleDays[scheduleDays.length - 1].day).toDate();
            viewShifts = filteredShifts.filter(shift =>
                isWithinInterval(moment(shift.date).toDate(), { start, end })
            );
        }

        let baseForCounts = viewShifts;
        if (!showAll) {
            if (selectedScheduleId == null) {
                baseForCounts = baseForCounts.filter(x => x.published === true);
            } else {
                baseForCounts = baseForCounts.filter(x => x.scheduleId === selectedScheduleId);
            }
        } else if (selectedScheduleId != null) {
            baseForCounts = baseForCounts.filter(x => x.scheduleId === selectedScheduleId);
        }

        const conflictCount = baseForCounts.filter(x => x.conflicts).length;
        const openShiftCount = baseForCounts.filter(x => !x.assignedShiftID).length;

        const enrich = (list = []) => list.map(user => {
            if (!user || user.userId == null) {
                return { ...user };
            }

            const userShifts = viewShifts.filter(shift => shift.userId === user.userId);
            const overtimeHours = this.calculateOvertimeHours(
                userShifts,
                user.salariedOvertimeEligible,
                user.payrollType,
                user.salariedStartDate,
                user.wage
            );
            const totalShiftHours = userShifts.reduce((sum, shift) => sum + (shift.shiftHours || 0), 0);
            const paySummary = this.calculateEmployeePay(user, userShifts, { calendarDays: scheduleDays });

            return {
                ...user,
                shifts: userShifts,
                totalShiftHours,
                overtimeHours,
                totalPay: paySummary.totalPay,
                paySummary
            };
        });

        const enrichedEmployees = enrich(employees || []);
        const enrichedFilteredEmployees = enrich(filteredEmployees || []);
        const usersWithOvertime = enrichedFilteredEmployees.filter(
            user => user && user.userId && user.overtimeHours > 0
        );

        this.setState({
            filteredViewShifts: viewShifts,
            conflictCount,
            openShiftCount,
            employees: enrichedEmployees,
            filteredEmployees: enrichedFilteredEmployees,
            usersWithOvertime
        });
    }

    inScheduleRange = (day) => {
        const scheduleStart = this.state.selectedSchedule?.[0]?.scheduleStart ? moment(this.state.selectedSchedule[0].scheduleStart) : null;
        const scheduleEnd = this.state.selectedSchedule?.[0]?.scheduleEnd ? moment(this.state.selectedSchedule[0].scheduleEnd) : null;
        const currentDay = moment(day);

        return scheduleStart && scheduleEnd
                ? currentDay.isBetween(scheduleStart, scheduleEnd, 'day', '[]') // inclusive
                : scheduleStart
                    ? currentDay.isSameOrAfter(scheduleStart, 'day')
                    : scheduleEnd
                        ? currentDay.isSameOrBefore(scheduleEnd, 'day')
                        : false; // no start/end means not in schedule
    }

    inSelectedSchedule = (day) => {
        const scheduleStart = this.state.selectedSchedule?.[0]?.scheduleStart ? moment(this.state.selectedSchedule[0].scheduleStart) : null;
        const scheduleEnd = this.state.selectedSchedule?.[0]?.scheduleEnd ? moment(this.state.selectedSchedule[0].scheduleEnd) : null;
        const currentDay = moment(day);
        return this.state.selectedSchedule?.[0]?.published && !day?.schedule?.published
            ? false
            : !this.state.selectedSchedule?.[0]?.published &&
                !(currentDay.isSameOrAfter(scheduleStart ?? moment(), 'day') &&
                    currentDay.isSameOrBefore(scheduleEnd ?? moment(), 'day'))
                ? false
                : true;
    }
   
    setConflictOpenCount = (conflict, open) => {
        this.setState({
            conflictCount: conflict,
            openShiftCount: open,
        })
    }
    
    availableConflicts = function (startTime, endTime, unavailable, user) {
        let weekdayStart = moment(startTime).day() + 1;
        let weekdayEnd = moment(endTime).day() + 1;

        unavailable = unavailable.filter(x => !x.prefer);

        return _.some(unavailable, function (e) {
            if (e.day === weekdayStart || (weekdayStart !== weekdayEnd && e.day === weekdayEnd)) {
                let dayToUse = (e.day === weekdayStart) ? startTime : endTime;
                if (e.allDay) {
                    // Only skip the conflict when the allDay unavailability is on the
                    // overnight END day and the shift ends exactly at midnight
                    // (i.e. it doesn't actually extend into that day).
                    if (e.day === weekdayEnd && weekdayStart !== weekdayEnd &&
                        moment(endTime).isSame(moment(endTime).startOf('day'))) {
                        return false;
                    }
                    return true;
                } else {
                    let availStart = moment(moment(dayToUse).format('YYYY-MM-DD') + " " + e.startTime);
                    let availEnd = moment(moment(dayToUse).format('YYYY-MM-DD') + " " + e.endTime);

                    // Handle overnight unavailability
                    if (availEnd.isSameOrBefore(availStart)) {
                        availEnd.add(1, 'day');
                    }

                    let shiftStart = moment(startTime);
                    let shiftEnd = moment(endTime);

                    // Handle overnight shift
                    if (shiftEnd.isSameOrBefore(shiftStart)) {
                        shiftEnd.add(1, 'day');
                    }



                    var test = shiftStart.isBefore(availEnd) && shiftEnd.isAfter(availStart);

                    // Return true only if there is actual overlap (not just touching)
                    return shiftStart.isBefore(availEnd) && shiftEnd.isAfter(availStart);
                }
            }
            return false;
        });
    };
    availableConflictsPto = function (startDate, endTime, pto) {
        return _.some(pto, function (e) {
            let availStart = moment(e.fromDate).toDate();
            let availEnd = moment(e.toDate).toDate();

            return areIntervalsOverlapping(
                { start: availStart, end: availEnd },
                { start: moment(startDate).toDate(), end: moment(endTime).toDate() }
            )
        })
    }

    filterEmployeesXAvailability = (avail, employees) => {
        employees.forEach(user => {
            // Reset values first
            user.requestedOff = 0;
            user.unavailable = 0;
            user.conflicts = false;

            if (user.pto.length > 0) {
                if (this.availableConflictsPto(avail.fullStartTime, avail.fullEndTime, user.pto)) {
                    user.requestedOff = 1;
                    return;
                }
            }

            if (this.availableConflicts(avail.fullStartTime, avail.fullEndTime, user.availability)) {
                user.unavailable = 1;
            }
        });

        return employees.filter(x => x.requestedOff !== 1 && x.unavailable !== 1);
    };

    filterEmployees = () => {
        let emp = this.state.employees;
        const { filterXEmployees, filterXRoles, filterXDepartmentRoles } = this.state;
        
        let filteredEmp = emp.filter(x => (filterXRoles.findIndex(element => x.roles.map(z => z.roleId).includes(element)) > -1 || filterXRoles.length == 0)
            && (filterXDepartmentRoles.findIndex(element => x.roles.map(z => z.roleId).includes(element)) > -1 || filterXDepartmentRoles.length == 0)
            && (filterXEmployees.includes(x.userId) || filterXEmployees.length == 0));

        this.setState({
            filteredEmployees: _.sortBy(filteredEmp, ["role", "firstName"]) //_.sortBy(filteredEmp, ["firstName"])
        }, this.recalculateShiftSummaries)
    }

    setFilterXEmployees = (x) => {
        this.setState({
            filterXEmployees: x
        }, () => {
            this.filterShifts();
            this.filterEmployees();
        })
    }

    setFilterXShifts = (x) => {
        this.setState({ filterXShifts: x }, () => this.filterShifts())
    }

    setFilterXJobCodes = (x) => {
        this.setState({ filterXJobCodes: x }, () => {
            this.filterShifts();
            this.filterEmployees();
        })
    }

    setFilterXRoles = (x) => {
        this.setState({ filterXRoles: x }, () => {
            this.filterShifts();
            this.filterEmployees();
        })
    }

    setFilterXDepartments = (x, d) => {
        this.setState({ filterXDepartmentRoles: x, filterXDepartment: d }, () => {
            this.filterShifts();
            this.filterEmployees();
        })
    }

    setFilterXAvailability = (x) => {
        this.setState({
            filterAvailability: x
        })
    }

    clearSchedule = (x) => {
        this.setState({ clearingScheduler: x })
    }

    setSelectedDay = (date) => {
        this.setState({ selectedDay: date })
    }

    getMonthCalendarRange = (selectedDate) => {
        const base = moment(selectedDate).toDate();

        // first day of month → start of its week
        const start = this.startOfWeek(startOfMonth(base));

        // 6-row month grid: start + 5 weeks, then include the last 7 days
        const end = addDays(addWeeks(this.startOfWeek(startOfMonth(base)), 5), 6);

        return { start, end };
    };

    // Used for BUILD (respects the active viewType)
    getVisibleRange = (selectedDate, viewType = this.state.scheduleType) => {
        const base = moment(selectedDate).toDate();
        const isMonth = viewType === "month";
        const start = isMonth ? this.startOfWeek(startOfMonth(base)) : this.startOfWeek(base);
        const end = isMonth ? addDays(addWeeks(this.startOfWeek(startOfMonth(base)), 5), 6)
            : addDays(start, 6);
        return { start, end };
    };

    // hard refresh data this.setState({ /* removed loadedRange cache */ }, this.refreshVisibleData);
    refreshVisibleData = (viewType = this.state.scheduleType) => {
        const { selectedDay } = this.state;
        // 1) Always (re)build the grid for the requested view
        this.buildViewDaysFromRange(selectedDay, viewType);

        // 2) Fetch the shifts for the requested month range (no local loaded-range cache)
        const monthRange = this.getMonthCalendarRange(selectedDay);
        this.getShiftsForRange(monthRange.start, monthRange.end).then(() => {
            // intentionally no loadedRange state maintained here
        });
    };

    // --- fetching (range-based) ---
    getShiftsForRange = (startDate, endDate) => {
        this.setState({ isFetchingShifts: true });
        this.getJobs(this.state.selectedScheduleId, startDate, endDate)
        return axios
            .get(
                `${AUTH_CONFIG.API_URL}/api/Schedules/GetScheduledShifts` +
                `?facilityId=${this.state.facilityId}` +
                `&start=${moment(startDate).format('YYYY-MM-DD')}` +
                `&end=${moment(endDate).format('YYYY-MM-DD')}`
            )
            .then((response) => {
                response.data.templates.forEach((t) => {
                    const i = response.data.shifts.findIndex(s => s.schedule_x_ShiftId === t.schedule_x_ShiftId);
                    if (i >= 0) {
                        if (!response.data.shifts[i].templates) response.data.shifts[i].templates = [];
                        t.fromTemplate = false;
                        response.data.shifts[i].templates.push(t);
                    }
                });

                this.setState(
                    { shifts: response.data.shifts, isFetchingShifts: false },
                    () => this.filterShifts()
                );
            });
    };

    hardRefreshShifts = () => {
        this.setState({ isFetchingJobs: false }, this.refreshVisibleData);
    }

    // selectedDate: string|Date
    // viewType: 'month' | 'week' (default from context)
    // selectedSchedule: optional override (defaults to state)
    buildViewDaysFromRange = (selectedDate, viewType = this.state.scheduleType) => {
        const { schedules = [] } = this.state;

        const { start, end } = this.getVisibleRange(selectedDate, viewType);
        const viewDays = eachDayOfInterval({ start, end });

        const pickScheduleForDate = (day) => {
            const dayDate = moment(day).toDate();

            // Only consider schedules with valid bounds that include the day
            const candidates = schedules.filter(s =>
                s?.scheduleStart && s?.scheduleEnd &&
                isWithinInterval(dayDate, {
                    start: moment(s.scheduleStart).toDate(),
                    end: moment(s.scheduleEnd).toDate(),
                })
            );
            if (candidates.length === 0) return null;

            const byLatestStart = (a, b) =>
                new Date(b.scheduleStart).getTime() - new Date(a.scheduleStart).getTime();

            const selected = candidates.find(s => s.selected);
            const published = candidates.filter(s => s.published);
            const drafts = candidates.filter(s => !s.published);

            // Prefer published:
            if (published.length) {
                // If the selected schedule is published and covers the day, keep it
                if (selected?.published) return selected;
                // Otherwise, pick the published one with the latest start
                return published.sort(byLatestStart)[0];
            }

            // No published candidates: fall back to selected (even if draft)
            if (selected) return selected;

            // Otherwise, use the latest-start draft
            return drafts.sort(byLatestStart)[0] || null;
        };

        const calObject = viewDays.map((d) => ({
            day: moment(d).format('YYYY-MM-DD') + 'T00:00:00',
            schedule: pickScheduleForDate(d),
        }));

        this.setState({ scheduleDays: calObject }, this.recalculateShiftSummaries);
    };

    // --- UI event wires (all end in refreshVisibleData) ---
    setSelectedDate = (date) => {
        debugger;
        this.setState({ selectedDay: date }, this.refreshVisibleData);
    };

    setSelectedSchedule = (id) => {
        const model = { Id: id, FacilityId: this.state.facilityId };

        // toggle flags locally
        this.state.schedules.forEach(s => (s.selected = s.scheduleId === id));
        const schedules = [...this.state.schedules];

        const selected = schedules.filter(x => x.selected);
        const fallbackPublished = schedules.filter(x => x.published);
        const schedule = selected.length ? selected : fallbackPublished;

            this.setState(
            {
                selectedScheduleId: id,
                schedules,
                selectedDay: id ? schedule[0].scheduleStart : moment().format('YYYY-MM-DD'),
                selectedSchedule: schedule,
                publishedSelected: selected.length === 0,
                jobs: [],
                isFetchingJobs: false
            },
                () => {
                this.refreshVisibleData();
                axios.post(`${AUTH_CONFIG.API_URL}/api/Schedules/SetSelectedSchedule`, model);
            }
        );
    };

    getSchedules = (refresh) => {
        axios
            .get(`${AUTH_CONFIG.API_URL}/api/Schedules/GetSchedules?facilityId=${this.state.facilityId}`)
            .then((response) => {
                const schedules = response.data || [];
                const selected = schedules.filter(x => x.selected);
                const schedule = selected.length ? selected : schedules.filter(x => x.published);
                const scheduleId = selected.length ? selected[0].scheduleId : null;
                const minDate =
                    (schedules.find(x => x.published)?.scheduleStart) ??
                    (schedules[0]?.scheduleStart) ??
                    (schedule?.scheduleStart) ??
                    moment().format('YYYY-MM-DD');

                this.setState(
                    {
                        schedules,
                        selectedScheduleId: scheduleId,
                        selectedDay: schedule.length && !schedule[0].published
                            ? schedule[0].scheduleStart
                            : (this.state.selectedDay || moment().format('YYYY-MM-DD')),
                        selectedSchedule: schedule,
                        minScheduleDate: moment(minDate).toDate(),
                        initLoading: false,
                        unpublishedAutofill: false,
                        publishedSelected: selected.length === 0
                    }, () => {
                        if (refresh) {
                            this.setState({ jobs: [], isFetchingJobs: false }, this.refreshVisibleData);
                        } else {
                            this.refreshVisibleData();
                        }
                    }
                );
            });
    };

    getFormsForShifts = () => {
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetFormsForShifts")
            .then((response) => {
                this.setState({
                    formsForShifts: response.data
                })
            });
    }

    setCopiedWeekSelection = ({ scheduleId, days }) => {
        const normalizedDays = Array.isArray(days) ? Array.from(new Set(days.map(day => day ? moment(day).format('YYYY-MM-DD') : null).filter(Boolean))) : [];
        this.setState({
            copiedScheduleId: scheduleId || null,
            copiedWeekDays: normalizedDays
        });
    }

    clearCopiedWeekSelection = () => {
        this.setState({
            copiedScheduleId: null,
            copiedWeekDays: []
        });
    }

    isShiftInCopiedWeek = (scheduleId, date) => {
        const { copiedScheduleId, copiedWeekDays } = this.state;
        if (!copiedScheduleId || scheduleId == null) {
            return false;
        }
        if (Number(copiedScheduleId) !== Number(scheduleId)) {
            return false;
        }
        if (!date) {
            return false;
        }
        const normalized = moment(date).format('YYYY-MM-DD');
        return copiedWeekDays.includes(normalized);
    }

    setShiftsManual = (shifts) => {
        this.setState({
            shifts: shifts
        }, () => this.filterShifts())
    }

    refreshShifts = () => {
        this.filterShifts();
    }

    setScheduleType = (type) => {
        this.setState({
            scheduleType: type
        })
    }

    setUsersWithOvertime = (count) => {
        this.setState({
            usersWithOvertime: count
        })
    }

    setSchedules = (s) => {
        this.setState({
            schedules: s
        })
    }

    toggleProfilePic = () => {
        this.setState({
            showProfilePic: !this.state.showProfilePic
        })
    }

    getUnfinishedCourses = () => {
        this.setState({fetchingCourses:true})
        axios.get(AUTH_CONFIG.API_URL + "/api/course/GetUnfinishedCourses")
            .then((response) => {
                this.setState({
                    unfinishedCourses: response.data,
                    fetchingCourses:false
                });
            });
    }

    setNavOpen = () => {
        
        this.setState({
            navOpen: !this.state.navOpen
        })
    }

    render() {
        const { children } = this.props
        const { navOpen, filterXRoles, showAll, showTotals, showFilterbar, selectedSchedule, filterXShifts, filterXEmployees, filterXDepartmentRoles, filterXDepartment, showProfilePic, initLoading, showAvail, fetchingCourses, trial, unfinishedCourses, weather, shiftTypes, minScheduleDate, selectedScheduleId, filterAvailability, usersWithOvertime, openShiftCount, scheduleType, shifts, selectedDay, calendarStartDate, formsForShifts, calendarEndDate, calendarShifts, jobs, isFetchingJobs, isFetchingShifts, schedules, scheduleDays, filteredShifts, filteredViewShifts, autoFillOnly, filteredEmployees, conflictCount, unpublishedAutofill, itemIndrag, scheduleConflictsOnly, clearingScheduler, publishedSelected, jobCodes, filterXJobCodes } = this.state
    const { isStartOfWeek, inScheduleRange, setIsFetchingJobs, inSelectedSchedule, setShowAll, refreshVisibleData, hardRefreshShifts, calculateOvertimeHours, isDayBeforeStartOfWeek, setNavOpen, refreshShifts, toggleProfilePic, setShowAvail, setFilterXDepartments, setTrial, getShiftTypes, getUnfinishedCourses,fetchWeather, startOfWeek, setSchedules, setUsersWithOvertime, setFilterXAvailability, filterEmployeesXAvailability, setSelectedDate, setConflictOpenCount, setScheduleType, setShiftsManual, getSchedules, getJobs, setSelectedDay, setFilterXShifts, showAutoFillOnly, setFilterXEmployees, setFilterXRoles, setItemIndrag, showsScheduleConflictsOnly, clearSchedule, setSelectedSchedule, getFormsForShifts, getJobCodes, setFilterXJobCodes } = this

        return (
            <ShiftsContext.Provider
                value={{
                    autoFillOnly,
                    showAutoFillOnly,
                    showAll,
                    showTotals,
                    showFilterbar,
                    setShowFilterbar: this.setShowFilterbar,
                    inScheduleRange,
                    inSelectedSchedule,
                    setIsFetchingJobs,
                    setShowAll,
                    setShowTotals: this.setShowTotals,
                    isStartOfWeek,
                    selectedSchedule,
                    refreshVisibleData,
                    hardRefreshShifts,
                    calculateOvertimeHours,
                    calculateEmployeePay: this.calculateEmployeePay,
                    isDayBeforeStartOfWeek,
                    navOpen,
                    setNavOpen,
                    useNewNav: USE_NEW_NAV,
                    refreshShifts,
                    showProfilePic,
                    filterXEmployees,
                    filterXDepartment,
                    filterXDepartmentRoles,
                    filterXShifts,
                    filterXRoles,
                    filterXJobCodes,
                    setFilterXJobCodes,
                    toggleProfilePic,
                    unfinishedCourses,
                    getUnfinishedCourses,
                    getShiftTypes,
                    fetchingCourses,
                    fetchWeather,
                    weather,
                    trial,
                    setTrial,
                    minScheduleDate,
                    startOfWeek,
                    initLoading,
                    shiftTypes,
                    jobCodes,
                    getJobCodes,
                    filterAvailability,
                    filterEmployeesXAvailability,
                    setFilterXAvailability,
                    setFilterXDepartments,
                    shifts,
                    filteredViewShifts,
                    setConflictOpenCount,
                    selectedDay,
                    openShiftCount,
                    scheduleType,
                    showAvail,
                    setShowAvail,
                    getSchedules,
                    getJobs,
                    setSelectedDate,
                    setScheduleType,
                    setUsersWithOvertime,
                    setSelectedDay,
                    calendarStartDate,
                    calendarEndDate,
                    calendarShifts,
                    jobs,
                    isFetchingJobs,
                    isFetchingShifts,
                    setShiftsManual,
                    schedules,
                    setSchedules,
                    scheduleDays,
                    filteredShifts,
                    filteredEmployees,
                    setFilterXShifts,
                    setFilterXEmployees,
                    setFilterXRoles,
                    conflictCount,
                    usersWithOvertime,
                    itemIndrag,
                    setItemIndrag,
                    showsScheduleConflictsOnly,
                    scheduleConflictsOnly,
                    clearingScheduler,
                    publishedSelected,
                    clearSchedule,
                    setSelectedSchedule,
                    unpublishedAutofill,
                    selectedScheduleId,
                    formsForShifts,
                    getFormsForShifts,
                    copiedScheduleId: this.state.copiedScheduleId,
                    copiedWeekDays: this.state.copiedWeekDays,
                    setCopiedWeekSelection: this.setCopiedWeekSelection,
                    clearCopiedWeekSelection: this.clearCopiedWeekSelection,
                    isShiftInCopiedWeek: this.isShiftInCopiedWeek,
                    showCreateSchedule: this.state.showCreateSchedule,
                    openCreateSchedule: this.openCreateSchedule,
                    closeCreateSchedule: this.closeCreateSchedule
                }}
            >
                {children}
            </ShiftsContext.Provider>
        )
    }
}

export default ShiftsContext;

function mapStateToProps(state) {
    if (state.appState.product) {
        const facilityId = state.appState.product.facility.facilityID;
        const employees = state.appState.product.facility.employees;
        const StartOfWorkweek = state.appState.clientSettings.startOfWorkweek;
        const overtimeSettings = state.appState.product.facility.overtimeSettings;
        const clientsModule = state.appState.clientSettings.clientsModule;

        return {
            facilityId,
            employees,
            StartOfWorkweek,
            overtimeSettings,
            clientsModule
        }
    }
    else {
        return {};
    }
}


export const ShiftProvider = connect(mapStateToProps)(ShiftsProvider);

